module.exports = __webpack_public_path__ + "static/media/gifFive.d8cead38.gif";